import { PayeeCheckType, VerifyPayeeCheckResponseCode } from '@seapoint/server/enums';
import { PayeeCheckView } from '../../types/entity-types';

type VopPayeeCheck = Omit<PayeeCheckView, 'type' | 'code'> & {
  type: PayeeCheckType.VERIFY_PAYEE;
  code: VerifyPayeeCheckResponseCode;
};

export const isVopPayeeCheck = (payeeCheck?: PayeeCheckView): payeeCheck is VopPayeeCheck => {
  if (!payeeCheck) {
    return false;
  }

  return payeeCheck.type === PayeeCheckType.VERIFY_PAYEE;
};
